import { Injectable } from '@angular/core';
import { Observable ,  of } from 'rxjs';
import { HttpClientHelper } from '../http-helper';
import { ApiUrlHelper } from '../api-url-helper';
import { CommentTransFormer } from '../../_transformers/comment.transformer';
import { map ,delay} from 'rxjs/operators';
import { Utility } from '../utility';

@Injectable()
export class CommentListService  {
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,
        private _commentTransFormer: CommentTransFormer,
        private _utility:Utility
    ) { }
    
    delaySomeMillsecond(millsec):Date
    {
        var dateObj = Date.now();
        dateObj += millsec;
        return new Date(dateObj);
    }
    getComments(videoId, page, size = 10,orderStyle = 0, isAlbum = false): Observable<any> {
        const de = page === 1 ? 0 : this.delaySomeMillsecond(200);
        const apiURL = this._apiUrlHelper.urlBuilder('comment-list',
         { id: videoId, page: page, pagesize: size, type: '1',orderBy:orderStyle, a:  this._utility.isNews?'1':'',cinema: isAlbum?'7':'1' },
         this._utility.isNews?"NEWS_ENDPOINT":"");
        return this
            ._httpClientHelper
            .get(apiURL)
            .pipe(map(res => {
                var hot = [];
                var normal = [];
                if(!!res && res.length >0)
                {
                    if(!!res[0].commHot)
                    {
                        hot = res[0].commHot.map(
                            item => {
                                return this._commentTransFormer.fromList(item, this._utility.isNews);
                            });
                    }
                    if(!!res[0].commNormal)
                    {
                        normal = res[0].commNormal.map(
                            item => {
                                return this._commentTransFormer.fromList(item,  this._utility.isNews);
                            });
                    }
                }

                return {
                    topComments: hot,
                    comments: normal,
                    count: res[0].childrenCount || res[0].recordSum || 0
                };
            })).pipe(delay(de));
    }
}
